function find(map, keyToFind) {
  for (const [key, value] of map) {
    if (_.isEqual(keyToFind, key)) {
      return value;
    }
  }
}

export default function (fn, ...args) {
  let memoizedPartialFn;

  if (fn._memoizeCache) {
    memoizedPartialFn = find(fn._memoizeCache, args);
  } else {
    fn._memoizeCache = new Map();
  }

  if (!memoizedPartialFn) {
    memoizedPartialFn = _.partial(fn, ...args);
    fn._memoizeCache.set(args, memoizedPartialFn);
  }
  return memoizedPartialFn;
}



// WEBPACK FOOTER //
// ./src/shared/utils/memoized-partial.js